export default __webpack_public_path__ + "static/media/solera-logo-white.29d724fb.svg";